import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';

type Props = {
  children: React.ReactNode;
  // eslint-disable-next-line react/no-unused-prop-types
  fixedOnly?: Breakpoint[];
};

const useStyles = (props: Props) => {
  const { fixedOnly } = props;
  return makeStyles((theme: Theme) => ({
    bottomBar: {
      backgroundColor: theme.palette.common.white,
      bottom: 0,
      boxSizing: 'border-box',
      left: 0,
      padding: theme.spacing(1),
      width: '100vw',

      zIndex: theme.zIndex.appBar,

      [theme.breakpoints.only('xs')]: {
        borderTop: `1px solid ${theme.palette.grey[400]}`,
        position: () => (fixedOnly.includes('xs') ? 'fixed' : 'inherit'),
      },
      [theme.breakpoints.only('sm')]: {
        borderTop: `1px solid ${theme.palette.grey[400]}`,
        position: () => (fixedOnly.includes('sm') ? 'fixed' : 'inherit'),
      },

      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
  }))();
};

export function BottomBar(props: Props): JSX.Element {
  const classes = useStyles(props);
  const { children } = props;

  return <div className={classes.bottomBar}>{children}</div>;
}
